import React from "react";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { usePushAdded } from "./usePushAdded";

const THIS_PAGE_COLOR = "#475569";

/**
 * Every page on the chart, this page first: an added page's line can be hidden from the chart, and the page
 * removed. `metrics` is null for an added page with no file.
 */
export default function ChartPages({ page, added, hiddenIds, onToggleHidden }) {
    const pushAdded = usePushAdded();
    if (added.length === 0) return null;
    const ids = added.map(({ id }) => id);
    return (
        <List>
            <Row>
                <Swatch $color={THIS_PAGE_COLOR} />
                <Path title={page.path}>{page.path}</Path>
                <Note>this page</Note>
            </Row>
            {added.map(({ id, path, color, metrics }) => {
                const hidden = hiddenIds.includes(id);
                return (
                    <Row key={id} $hidden={hidden}>
                        <Swatch $color={color} $dashed />
                        <Path title={path}>{path}</Path>
                        {metrics === null && <Note>no data</Note>}
                        <Button type="button" aria-label={`${hidden ? "Show" : "Hide"} ${path}`} aria-pressed={hidden} title={hidden ? "Show on the chart" : "Hide from the chart"}
                                onClick={() => onToggleHidden(id)}>
                            {hidden ? <VisibilityOffIcon style={{ fontSize: "0.95rem" }} /> : <VisibilityIcon style={{ fontSize: "0.95rem" }} />}
                        </Button>
                        <Button type="button" aria-label={`Remove ${path}`} title="Remove from the chart" onClick={() => pushAdded(ids.filter((each) => each !== id))}>
                            <CloseIcon style={{ fontSize: "0.95rem" }} />
                        </Button>
                    </Row>
                );
            })}
        </List>
    );
}

const List = styled.div`
    margin-top: 10px;
    border-top: 1px solid #f1f5f9;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 26px;
    padding: 2px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 0.74rem;
    opacity: ${({ $hidden }) => $hidden ? 0.45 : 1};
`;

const Swatch = styled.span`
    flex-shrink: 0;
    width: 18px;
    height: 0;
    border-top: 2px ${({ $dashed }) => $dashed ? "dashed" : "solid"} ${({ $color }) => $color};
`;

const Path = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
    color: #0f172a;
`;

const Note = styled.span`
    flex-shrink: 0;
    font-size: 0.66rem;
    color: #94a3b8;
`;

const Button = styled.button`
    display: inline-flex;
    flex-shrink: 0;
    padding: 3px;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: #64748b;
    cursor: pointer;
    &:first-of-type { margin-left: auto; }
    &:hover { background: #f1f5f9; color: #0f172a; }
`;
